import React, { PureComponent } from 'react';
import { Routes, setSelectorLabel } from '../../../../utils';
import { ListWrapper, ScreenWrapper } from '../../../components';
import { ActionsBar, Filter, ListItem } from '../../commons';
import './freemiumsList.scss';

export class FreemiumsList extends PureComponent {
  state = {
    freemiumsSelected: [],
  };

  componentDidMount() {
    const { getFreemiums } = this.props;
    this.initializeFilter();
    getFreemiums();
  }
  initializeFilter = () => {
    const { setCurrentFilter, isBoUserAdmin } = this.props;
    isBoUserAdmin &&
    setCurrentFilter(0, {
      search: '',
      region: 'all',
    });
  };
  handleSendMail = id => {
    const { freemiums } = this.props;
    const { all } = freemiums;

    const freemium = all.find(search => search.id === id);
    if (freemium) {
      window.location.href = `mailto:${freemium.details.email}`;
    }
  };

  onClick = id => () => {
    const { navigateTo } = this.props;
    navigateTo(Routes.FREEMIUM.replace(':freemiumId', id));
  };

  onPageChange = page => {
    const { freemiums, setCurrentFilter } = this.props;
    const { filter, page: oldPage } = freemiums;
    const { search, region } = filter;

    if (oldPage !== page) {
      setCurrentFilter(page, {
        search,
        region: region.key,
      });
    }
  };

  onFiltersChange = key => value => {
    const { freemiums, setCurrentFilter } = this.props;
    const { filter } = freemiums;

    if (key === 'search' || value.key !== filter[key].key) {
      const { search, region } = filter;
      let newFilter = {
        search,
        region: region.key,
      };

      if (key === 'search') {
        newFilter = { ...newFilter, [key]: value };
      } else {
        newFilter = { ...newFilter, [key]: value.key };
      }

      setCurrentFilter(0, newFilter);
    }
  };

  onClickCreate = () => {
    this.props.navigateTo(Routes.FREEMIUM_CREATION);
  };

  onClickDownload = () => {
    this.props.exportList();
  };

  onCheckChange = all => id => () => {
    const { showSnackBar, setActionSnackBar, hideSnackBar } = this.props;
    const { freemiumsSelected } = this.state;

    const newFreemiumsSelected = freemiumsSelected.some(item => item.id === id)
      ? freemiumsSelected.filter(item => !(item.id === id))
      : freemiumsSelected.concat(all.find(m => m.id === id));

    this.setState({
      freemiumsSelected: newFreemiumsSelected,
    });

    setActionSnackBar(this.onMailSend, 'send');
    newFreemiumsSelected.length > 0
      ? showSnackBar(
          newFreemiumsSelected.length === 1
            ? 'want_send_mail_freemium'
            : 'want_send_mail_freemiums'
        )
      : hideSnackBar();
  };

  onMailSend = () => {
    const { freemiumsSelected } = this.state;

    window.location.href = `mailto:?bcc=${freemiumsSelected
      .filter(e => (e.details.email !== undefined ? e.details.email : null))
      .map(e => e.details.email)
      .join(';')}`;

    this.setState({
      freemiumsSelected: [],
    });
  };

  onDeleteFreemium = id => {
    const { freemiums, deleteFreemium, setCurrentFilter } = this.props;
    const { page, filter, listed } = freemiums;
    const { search, region } = filter;

    deleteFreemium(id);

    if (listed.length === 1 && page > 0) {
      setCurrentFilter(page - 1, {
        search,
        region: region.key,
      });
    }
  };

  render() {
    const { strings, freemiums, regions, showPopup } = this.props;
    const { freemiumsSelected } = this.state;
    const { page, filter, all, listed, pageCount } = freemiums;
    const { search, region } = filter;

    const actions = [
      {
        label: 'freemium_delete_action',
        action: id =>
          showPopup(strings('confirm_delete_freemium'), () =>
            this.onDeleteFreemium(id)
          ),
      },
      {
        label: 'send_mail_action',
        action: id => this.handleSendMail(id),
      },
    ];
    return (
      <ScreenWrapper id={'freemiums'}>
        <Filter
          strings={strings}
          label={`${strings('freemiums')} (${all.length})`}
          currentSearch={search}
          currentRegion={region}
          regions={regions}
          onSearchChange={this.onFiltersChange('search')}
          onRegionChange={this.onFiltersChange('region')}
        />
        <ListWrapper
          strings={strings}
          className={`list-wrapper`}
          currentPage={page}
          pageCount={pageCount}
          onPageChange={this.onPageChange}
        >
          {all.length > 0 ? (
            listed.map(item => (
              <ListItem
                key={item.id}
                strings={strings}
                item={item}
                isChecked={freemiumsSelected.some(f => f.id === item.id)}
                onCheck={this.onCheckChange(all)}
                onClick={this.onClick}
                actions={actions}
              />
            ))
          ) : (
            <p className={'no-list'}>{strings('no_freemiums')}</p>
          )}
        </ListWrapper>
        <ActionsBar
          strings={strings}
          onClickDownload={this.onClickDownload}
          onClickCreate={this.onClickCreate}
        />
      </ScreenWrapper>
    );
  }
}
